const colors = [
    '#fff',
    '#cc2630',
    '#eab12e',
    '#72ae58',
    '#2aafd2',
    '#0446be',
    '#8061b1',
]

export default colors